import React, { useState, useEffect } from "react";
import Modal from "react-modal";
import CustomButton from "../components/CustomButton";

const SendBackForReworkModal = ({
  isModalVisible,
  setIsModalVisible,
  reworkHandler,
  title = "Voucher"
}) => {
  const [comment, setComment] = useState("");
  const [error, setError] = useState(false);

  const onRequestClose = () => {
    setIsModalVisible({ ...isModalVisible, isOpen: false });
  };

  useEffect(() => {
    if (!isModalVisible.isOpen) {
      setComment("");
      setError(false);
    }
  }, [isModalVisible.isOpen]);

  const handleRework = () => {
    const { data = [] } = isModalVisible || {};
    if (comment.length > 0) {
      reworkHandler({ data: data, comment: comment });
    } else {
      setError(true);
    }
  };

  return (
    <div className="flex justify-center items-center w-full">
      <Modal
        isOpen={isModalVisible.isOpen}
        onRequestClose={onRequestClose}
        ariaHideApp={false}
        style={{
          content: {
            display: "flex",
            justifyContent: "center",
            borderRadius: "1rem",
            background: "#fff",
            padding: "1.5rem",
            width: "30%",
            position: "relative",
          },
          overlay: {
            background: "#000000d6",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 1
          },
        }}
      >
        <div className="w-full">
          {/* Header */}
          <div className="flex justify-between relative w-[100%] text-2xl font-semibold">
            Send Back for Rework - {title || ""}
            <div
              className="text-3xl cursor-pointer text-red-500 ml-4"
              onClick={() => setIsModalVisible({ ...isModalVisible, isOpen: false })}
            >
              [x]
            </div>
          </div>
          <div className="mt-4">
            <div>WRITE REASON FOR REWORK</div>
            <textarea
              className="h-40 w-full border text-2xl mt-2 p-2"
              value={comment}
              onChange={(e) => {
                setComment(e.target.value);
                setError(false);
              }}
              placeholder="Please provide reason for sending back for rework..."
            />
            {error && (
              <span className="text-red-500 text-xl">
                Please write comments before sending back for rework
              </span>
            )}
          </div>
          <div className="w-full flex justify-end">
            <CustomButton
              title="Send Back for Rework"
              wrapperClassName="!px-10 mt-6"
              style={{
                background: "white",
                color: "#FF8C00",
                border: "1px solid #FF8C00",
              }}
              onClick={handleRework}
            />
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default SendBackForReworkModal;

